"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaginationQuerySchema = exports.PaginationSortSchema = void 0;
var zod_1 = require("zod");
exports.PaginationSortSchema = zod_1.z.object({
    sortField: zod_1.z.string(),
    sortDirection: zod_1.z.number(),
});
exports.PaginationQuerySchema = zod_1.z.object({
    limit: zod_1.z.number().max(10).min(1).default(10),
    skip: zod_1.z.number().min(0),
    sort: exports.PaginationSortSchema.optional(),
});
//# sourceMappingURL=PaginatedResults.js.map